import React from "react"
import { useStaticQuery, graphql } from 'gatsby'

import SEO from "../components/seo"

const LandingPageSEO = () => {

    const metaData = useStaticQuery(graphql`
        query {
            allWpCustomPage(filter: {databaseId: {eq: 1803}}) {
                edges {
                  node {
                    SEOmeta {
                        metaTitle
                        metaDescription
                        metaKeywords
                        ogTitle
                        ogDescription
                        ogImage {
                          localFile {
                            childImageSharp {
                              fluid(maxWidth: 1320, quality: 100) {
                                ...GatsbyImageSharpFluid_withWebp
                              }
                            }
                          }
                        }
                        twitterTitle
                        twitterDescription
                        twitterImage {
                          localFile {
                            childImageSharp {
                              fluid(maxWidth: 1320, quality: 100) {
                                ...GatsbyImageSharpFluid_withWebp
                              }
                            }
                          }
                        }
                      }
                  }
                }
              }
        }
    `)

    return(
        <div>
            {metaData.allWpCustomPage.edges.map(page => (
                <SEO 
                title={page.node.SEOmeta.metaTitle} 
                description={page.node.SEOmeta.metaDescription}
                keywords={page.node.SEOmeta.metaKeywords}
                ogTitle={page.node.SEOmeta.ogTitle} 
                ogDescription={page.node.SEOmeta.ogDescription}
                ogImage={page.node.SEOmeta.ogImage.localFile.childImageSharp.fluid}
                twitterTitle={page.node.SEOmeta.twitterTitle} 
                twitterDescription={page.node.SEOmeta.twitterDescription}
                twitterImage={page.node.SEOmeta.twitterImage.localFile.childImageSharp.fluid}
                />
            ))}
        </div>
    );

}

export default LandingPageSEO